import {Component, Renderer2} from '@angular/core';
import {ModalController, NavController, NavParams, Platform} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {EmailComposer} from "@ionic-native/email-composer";
import {File} from "@ionic-native/file";
import {DocumentViewer} from "@ionic-native/document-viewer";
import {SettingActiveContractorPage} from "../setting-active-contractor/setting-active-contractor";
import {GlobalProvider} from "../../providers/global/global";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {FileTransfer, FileTransferObject} from "@ionic-native/file-transfer";
import {FileOpener} from "@ionic-native/file-opener";
import * as moment from "moment";
import {Subscription} from "rxjs/Subscription";
import {ProtocolService} from "../../store/protocol/protocol.service";
import {ProtocolEntity} from "../../store/protocol/protocol.entity";
import {ContactEntity} from "../../store/contact/contact.entity";
import {AuditEntity} from "../../store/audit/audit.entity";
import {SettingService} from "../../store/setting/setting.service";
import {SettingEntity} from "../../store/setting/setting.entity";
import {ContactService} from "../../store/contact/contact.service";
import {AuditService} from "../../store/audit/audit.service";

/**
 * Generated class for the PruefungPdfPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-pruefung-pdf',
  templateUrl: 'pruefung-pdf.html',
})
export class PruefungPdfPage {

  public fileName: string = "";
  public createdAt: number = Date.now();
  public detail: boolean = true;
  public isBrowser: boolean = false

  public protokolle: Array<ProtocolEntity>;
  private _customer: ContactEntity;
  public pruefung: AuditEntity;

  public generatedProtokoll: Array<boolean> = [];

  private _protocolSubscription: Subscription;
  private _target: string = '_blank';

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private http: HttpClient,
              private emailComposer: EmailComposer,
              private file: File,
              private documentViewer: DocumentViewer,
              private globalProvider: GlobalProvider,
              private modalCtrl: ModalController,
              private loadingProvider: LoadingServiceProvider,
              private plt: Platform,
              private inAppBrowser: InAppBrowser,
              private renderer2: Renderer2,
              private fileTransfer: FileTransfer,
              private fileOpener: FileOpener,
              private protocolService: ProtocolService,
              private settingService: SettingService,
              private contactService: ContactService,
              private auditService: AuditService) {
    this.isBrowser = this.globalProvider.isBrowser();
    this._customer = this.navParams.get('customer');
    this.pruefung = this.navParams.get('pruefung');
    this._target = 'external'; //this.plt.is('ios') ? '_system' : '_blank';

    // this.protokollProvider.getByIds(this.pruefung.protokolle)
    //   .subscribe((protokolle) => {
    //     for(let i = 0, length = protokolle.length; i < length; i++){
    //       this.generatedProtokoll[protokolle[i]._id] = true;
    //     }
    //     this.protokolle = protokolle;
    //   });

    this.fileName = this.pruefung.pdf && this.pruefung.pdf.filename ? this.pruefung.pdf.filename : 'test';
  }

  ionViewWillEnter(){
    this._protocolSubscription = this.protocolService.getByIds(this.pruefung.protokolle)
      .subscribe((protocols: Array<ProtocolEntity>) => {
        for(let i = 0, length = protocols.length; i < length; i++){
          this.generatedProtokoll[protocols[i]._id] = true;
        }
        this.protokolle = protocols;
      })
  }

  public canGenerate(): boolean {
    for(let id in this.generatedProtokoll){
      if(this.generatedProtokoll[id] === true){
        return true;
      }
    }
    return false;
  }

  public send():void {

    let erstellungsDatumFormatted = moment(this.pruefung.erstellungsDatum).format('DD.MM.YYYY');

    let file = 'app://local/' + this.pruefung.filename + '.pdf';
    let fileDetail = 'app://local/' + this.pruefung.filename + '_detail.pdf';

    let email = {
      to: this._customer.mail || '',
      // bcc: this.contractor.mail,
      attachments: [
        file,
        fileDetail
      ],
      subject: 'Protokolle der Prüfung vom ' + erstellungsDatumFormatted,
      body: "Sehr geehrte Damen und Herren,\n\nanbei die Prüfprotokolle der UVV-Prüfung vom " + moment(this.pruefung.erstellungsDatum).format('DD.MM.YYYY') + '. \n\n\n\nMit freundlichen Grüßen',
      isHtml: false
    };

// Send a text message using default options
    this.emailComposer.open(email);
  }

  private _getProtokollStatus(): Array<string> {
    let protokollStatus: Array<string> = [];
    for(let protokollId in this.generatedProtokoll){
      if(this.generatedProtokoll[protokollId] === true){
        protokollStatus.push(protokollId);
      }
    }
    return protokollStatus;
  }

  private _openPDFForBrowser(url: string): void {
    setTimeout(() => {
      let link = this.renderer2.createElement('a');
      link.setAttribute('href', url);
      link.click();
    }, 300);
  }

  private _sendInformationForPDFGeneration(): Promise<any> {

    //todo: implementieren
    return new Promise((resolve, reject) => {
      this._selectContractorOrShowContractorList()
        .then((contractor) => {
          this.loadingProvider.present('PDF wird erstellt. Bitte warten...');
          return this.http.post(this.globalProvider.apiURL+'/v1/generatePDF', {databaseName: this.globalProvider.database.name, pruefungId: this.pruefung._id, userUUID: this.globalProvider.user.uuid, protokollStatus: this._getProtokollStatus()})
            .finally(() => {
              this.loadingProvider.dismiss();
            })
            .subscribe((response: {meta: {success: boolean}}) => {
              if(response.meta.success){
                resolve(response);
              }
              else{
                reject(response);
              }
            })
        }, (error) => {
          console.log(error);
          reject();
        })
    });



  }

  public generatePDFForBrowser():void {
      this._sendInformationForPDFGeneration()
        .then((successResponse) => {
          this.pruefung['pdf'] = {
            filename: 'test'
          };
          this._openPDFForBrowser(this.globalProvider.apiURL+'/v1/getPDF/'+this.pruefung._id + (this.detail ? '_detail' : ''));
        }, (errorResponse) => {
          alert('PDF konnte nicht erstellt werden');
        })
  }

  public generatePDF():void {

    //todo: implementieren
    this._sendInformationForPDFGeneration()
      .then((successResponse) => {
        //pdf is generated on server
        //download it
        let url_normal = this.globalProvider.apiURL+'/v1/getPDF/'+this.pruefung._id;
        let url_detail = this.globalProvider.apiURL+'/v1/getPDF/'+this.pruefung._id + '_detail';

        let fileTransfer: FileTransferObject = this.fileTransfer.create();
        let download_normal = fileTransfer.download(url_normal, this.file.dataDirectory + this.fileName + '.pdf');
        let download_detail = fileTransfer.download(url_detail, this.file.dataDirectory + this.fileName + '_detail.pdf');

        Promise.all([download_normal, download_detail])
          .then(() => {
            console.log('pdf´s download successfull');
            this.pruefung['filename'] = this.fileName;
            this.auditService.set(this.pruefung, false);
            // this.dataProvider.updateDocument(this.pruefung);
          }, (error) => {
            console.log('error while downloading pdf´s');
            console.dir(error);
          })

        // let blob_detail = new Blob([new Uint8Array(successResponse.detail.data).buffer]);
        // let blob_normal = new Blob([new Uint8Array(successResponse.normal.data).buffer]);
        //
        // Promise.all([
        //     this.file.writeFile(this.file.applicationDirectory, 'test_detail.pdf', blob_detail, {replace: true}),
        //     this.file.writeFile(this.file.applicationDirectory, 'test.pdf', blob_normal, {replace: true})
        // ])
        //   .then(() => {
        //     this.pruefung['pdf'] = [{
        //       filename: 'test'
        //     }];
        //     this.dataProvider.updateDocument(this.pruefung);
        //   });
      }, (errorResponse) => {
        alert('PDF konnte nicht erstellt werden');
      })

    this._selectContractorOrShowContractorList()
      .then((contractor) => {
        // this.http.post(this.serverURL, {...this.pruefung, protokolleRaw: this.protokolle, customer: this._customer, contractor: contractor})
        this.http.post(this.globalProvider.apiURL+'/v1/generatePDF', {databaseUUID: this.globalProvider.database.uuid, pruefungId: this.pruefung._id, userUUID: this.globalProvider.user.uuid, protokollStatus: this._getProtokollStatus()})
          .subscribe((response: any) => {

            let blob_detail = new Blob([new Uint8Array(response.detail.data).buffer]);
            let blob_normal = new Blob([new Uint8Array(response.normal.data).buffer]);

            Promise.all([this.file.writeFile(this.file.applicationDirectory, 'test_detail.pdf', blob_detail, {replace: true}), this.file.writeFile(this.file.applicationDirectory, 'test.pdf', blob_normal, {replace: true})])
              .then(() => {
                this.pruefung['pdf'] = {
                  filename: 'test'
                };
                this.auditService.set(this.pruefung, false);
                // this.dataProvider.updateDocument(this.pruefung);
              });

          }, (error) => {
            alert('PDF konnte nicht erstellt werden');
          })
      })
  }

  public openPDF(): void {

    this._isPDFFileAvailable()
      .then(() => {
        let filePath = this.file.dataDirectory;
        let fileName = this.pruefung.filename;
        if(this.detail){
          fileName += '_detail'
        };
        fileName += '.pdf';

        filePath = filePath + fileName;
        console.log('try to show:' + filePath);


        this.fileOpener.open(filePath, 'application/pdf')
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error openening file', e));
      }, () => {
        //pdfs müssen generiert werden. evtl. hat der nutzer die PDF´s von hand gelöscht. -> filename von pruefung muss gelöscht werden.
        this.pruefung.filename = null;
        this.auditService.set(this.pruefung, false);
        // this.dataProvider.updateDocument(this.pruefung);
        console.log('some or all pdf files are not found');
      })


  }

  private _isPDFFileAvailable(): Promise<any> {

    let fileName = this.pruefung.filename + '.pdf';
    let detailFileName = this.pruefung.filename + '_detail.pdf';

    let filePromise = this.file.checkFile(this.file.dataDirectory, fileName);
    let fileDetailPromise = this.file.checkFile(this.file.dataDirectory, detailFileName);

    return new Promise((resolve, reject) => {
      Promise.all([filePromise, fileDetailPromise])
        .then((result) => {
          console.dir(result);
          resolve(result);
        }, (error) => {
          console.dir(error);
          reject(error);
        })
    })


  }

  /*public openPDF(): void {

    var options = {
      title: this.pruefung.filename,
      documentView : {
        closeLabel : "Schließen"
      },
      navigationView : {
        closeLabel : "Schließen"
      },
      email : {
        enabled : true
      },
      print : {
        enabled : true
      },
      openWith : {
        enabled : true
      },
      bookmarks : {
        enabled : false
      },
      search : {
        enabled : true
      },
      autoClose: {
        onPause : false
      }
    };

    let filePath = this.file.dataDirectory;
    let fileName = this.pruefung.filename;
    if(this.detail){
      fileName += '_detail'
    };
    fileName += '.pdf';

    filePath = filePath + fileName;
    console.log('try to show:' + filePath);

    this.documentViewer.canViewDocument(filePath, 'application/pdf', options, () => {
      console.log('document can be shown');
      this.documentViewer.viewDocument(filePath, 'application/pdf', options, () => {
        console.log('documentViewer onShow');
      }, () => {
        console.log('documentViewer onClose');
      }, () => {
        console.log('documentViewer onMissingApp');
      }, (error) => {
        console.log('documentViewer onError');
        console.dir(error);
      });
    }, (appid, installer) => {
      console.log('app is missing');
    }, () => {
      console.log('show document is impossible');
    }, (error) => {
      console.log('canviewdocument error');
      console.dir(error);
    });
  }*/

  private _selectContractorOrShowContractorList(): Promise<any> {

    return new Promise((resolve, reject) => {
      this.settingService.get()
        .flatMap((setting: SettingEntity) => this.contactService.getById(setting.activeContractor))
        .take(1)
        .subscribe((contact: ContactEntity) => {

          if(contact){
            resolve(contact);
          } else {
            let _contractorModal = this.modalCtrl.create(SettingActiveContractorPage, {hasCloseButton: true}, {enableBackdropDismiss: true});
                  _contractorModal.present();
                  _contractorModal.onDidDismiss((contractor)=> {

                    console.dir(contractor);

                    if(contractor){
                      resolve(contractor);
                    } else {
                      reject();
                    }

                  })
          }
        })
    })


    // return this.dataProvider.getDocmentById(this.globalProvider.user.uuid)
    //   .then((settings) => {
    //     if(settings && settings.activeContractor){
    //       return this.dataProvider.getDocmentById(settings.activeContractor);
    //     }
    //     else{
    //       throw new Error();
    //     }
    //   })
    //   .catch(() => {
    //     //kein aktiven auftragnehmer ausgewählt.
    //     return new Promise((resolve, reject) => {
    //       let _contractorModal = this.modalCtrl.create(SettingActiveContractorPage, {hasCloseButton: true}, {enableBackdropDismiss: true});
    //       _contractorModal.present();
    //       _contractorModal.onDidDismiss((contractor)=> {
    //
    //         if(contractor){
    //           this.dataProvider.getDocmentById(this.globalProvider.user.uuid)
    //             .then((settingDocument) => {
    //               this.dataProvider.getDocmentById(settingDocument.activeContractor)
    //                 .then((contractor) => {
    //                   resolve(contractor);
    //                 }, (error) => {
    //                   reject(contractor);
    //                 })
    //             }, (error) => {
    //               reject(contractor);
    //             })
    //         }
    //         else {
    //           reject();
    //         }
    //       })
    //     })
    //   });
  }
}



// WEBPACK FOOTER //
// ./src/pages/pruefung-pdf/pruefung-pdf.ts